<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="title" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black f-16">
                    <form class="modal-tolak-transaksi">
                        <div class="form-group">
                            <div>
                                <label>{{ mContent }}</label>
                            </div>
                            <div class="m-t-12">
                                <SOInputRegular
                                    :title="'Alasan'"
                                    :placeholder="'Alasan'"
                                    :validation="'alphanumeric'"
                                    :required="true"
                                    v-model="keterangan"
                                />
                                <ErrorMessage class="error" label="Alasan" :validation="$v.keterangan" />
                            </div>
                        </div>
                    </form>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :outline="true"
                        :text="'Tolak'"
                        :full="true"
                        :id="`btn-${modalId}`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="doTolak"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "ModalTolakSetoran",
    components: {
        SOSlotModal,
        SOButton,
        SOInputRegular,
        ErrorMessage,
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            modalId: "modal-tolak-setoran",
            backLink: "mesin.edc.detail.setoran",
            title: "Tolak Settlement",
            mContent: "Tolak setoran settlement ini?",
            keterangan: "",
            isClick: false,
        };
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    validations: {
        keterangan: {
            required,
            minLength: minLength(2),
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            detailSettlementEdc: "detailSettlementEdc",
        }),
        getIdEdc() {
            return this.detailSettlementEdc.detail_data.idedc;
        },
    },
    methods: {
        ...mapActions({
            tolakSettlement: `${moduleName}/tolakSettlement`,
            setFetching: `${moduleName}/setFetching`,
            resetsetListSettlementEdc: `settlementEdcGlobalModule/resetsetListSettlementEdc`,
            resetPagination: `settlementEdcGlobalModule/resetPagination`,
        }),
        async back() {
            await this.$router.go(-1);
        },
        gotoPrevious() {
            this.$router.go(-1);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        errorValidation() {
            this.$v.keterangan.$touch();

            return this.$v.keterangan.$invalid;
        },
        doTolak() {
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let posted = {
                idsettlement_edc: this.$route.params.id_settlement,
                idedc: this.getIdEdc,
                alasan: this.keterangan,
            };

            let decline = this.tolakSettlement(posted);
            decline
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            this.$toast.success(msg);
                            this.resetsetListSettlementEdc();
                            this.resetPagination();
                            this.gotoPrevious();
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
